import { useEffect, useLayoutEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useLayout } from './core'
import { HeaderWrapper } from './components/header'
import { ScrollTop } from './components/scroll-top'
import { Content } from './components/content'
import { FooterWrapper } from './components/footer'
import { Sidebar } from './components/sidebar'
import { DrawerMessenger, InviteUsers, UpgradePlan } from '../partials'
import { PageDataProvider } from './core'
import { reInitMenu } from '../helpers'
import { ToolbarWrapper } from './components/toolbar'
import { DrawerTicketDetail } from '../partials/layout/drawer-messenger/DrawerTicketDetail'
import { SideModalIPList } from '../partials/widgets/_new/modal/SideModalIPList'
import { DrawerUserDetails } from '../partials/widgets/_new/drawers/DrawerUserDetails'
import { DrawerWithdrawHistory } from '../partials/widgets/_new/drawers/DrawerWithdrawHistory'
import { DrawerTransactionHistory } from '../partials/widgets/_new/drawers/DrawerTransactionHistory'
import { DrawerCryptoTransactionDetails } from '../partials/widgets/_new/drawers/DrawerCryptoTransactionDetails'

/** Path for Role Management page — must match PrivateRoutes `path='role-management'` */
const ROLE_MANAGEMENT_PATH = '/role-management'

const normalizePathname = (pathname: string) => {
  if (!pathname) return '/'
  const p = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname
  return p || '/'
}

const isRoleManagementRoute = (pathname: string) => {
  const p = normalizePathname(pathname)
  return p === ROLE_MANAGEMENT_PATH || p.endsWith('/role-management')
}

const MasterLayout = () => {
  const location = useLocation()
  const { setRightTolbar } = useLayout()

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  /**
   * Global right toolbar state persists across navigations. Role Management sets
   * `rolesmanagement` (Add Role). Pages that don't set their own toolbar leave it stale,
   * so "Add Role" can appear on wrong screens until refresh. Clear only that key when
   * leaving the role-management route (other toolbars: dashboard, usermanagement, etc. stay).
   */
  useLayoutEffect(() => {
    if (!isRoleManagementRoute(location.pathname)) {
      setRightTolbar((prev: string | unknown) =>
        prev === 'rolesmanagement' ? '' : prev
      )
    }
  }, [location.pathname, setRightTolbar])

  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />
          <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid'>
                <ToolbarWrapper />
                <Content>
                  <Outlet />
                </Content>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
      </div>

      {/* begin:: Drawers */}
      {/* <ActivityDrawer /> */}
      {/* <RightToolbar /> */}
      <DrawerMessenger />
      <DrawerTicketDetail />
      <SideModalIPList />
      <DrawerCryptoTransactionDetails />
      <DrawerUserDetails />
      <DrawerWithdrawHistory />
      <DrawerTransactionHistory />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export { MasterLayout }
